import { Directive, OnInit } from '@angular/core';
import { EmploymentAccessDataFetcherService } from '../services/employment-access-data-fetcher.service';

/**
 * @deprecated [HUMN-14868] directive only can fetch data, but there is no possibility to verify if fetching has been completed.
 * It also opens up the possibility of a memory leak occurrences when DOM reference will be destroyed faster than XHR resolved.
 */
@Directive({
  selector: '[pr-employment-access-context]',
  standalone: true,
})
export class EmploymentAccessContextDirective implements OnInit {
  constructor(private employmentAccessDataFetcherService: EmploymentAccessDataFetcherService) {}

  ngOnInit() {
    this.employmentAccessDataFetcherService.fetchManagedEmploymentsAccessData(true).subscribe();
  }
}
